import { Paper } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { IFilteringViewModel } from "../../_common/interface/table";
import { PageHeader } from "../../_components/header/page.header";
import { CommonTable } from "../../_components/table/common.table";
import { getDateStringNormalized } from "../../_helpers/dateTime.helper";
import { userOfficialNoteService } from "../../_services/userOfficialNote.service";
import { UserProfileOfficialNoteDrawer } from "./userProfile-officialNoteDrawerManage";


export function UserProfileOfficialNoteList(params: {}) {

    const { userId } = useParams<{ userId: string }>();
    let navigate = useNavigate();

    const [data, setData] = useState({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel | null>(null);

    useEffect(() => {
        if (filter)
            fetchData();
    }, [filter]);

    function fetchData() {
        if (!userId) return;
        setLoading(true);
        return userOfficialNoteService
            .getAll({ filter, userId: userId })
            .then(
                (json) => {
                    setData(json)
                }
            )
            .finally(() => setLoading(false));
    }

    function generateLicense(id: number) {
        navigate("" + id)
    }

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [

            {
                accessorKey: 'note',
                header: 'Note'
            },
            {
                accessorKey: 'date',
                header: 'Note Date',
                accessorFn: (rowData: any) => <>{getDateStringNormalized(rowData.date)}</>,
            },
            {
                accessorKey: 'createdBy',
                header: 'Created By'
            },
            // {
            //     accessorKey: 'isActive',
            //     header: 'Is Active',
            //     accessorFn: (rowData: any) => <>{rowData.isActive ? "Yes" : "No"}</>,
            // }
        ],
        [],
    );
    return (
        <>
            <PageHeader
                pageName="Notes"
                actionType="create"
                buttonName="New Note"
                onClick={() => { navigate("Create") }}
            />
            <Paper>
                <CommonTable
                    columns={columns}
                    data={data}
                    filter={filter}
                    setFilter={setFilter}
                    isLoading={isLoading}
                    onEdit={(d: any) => {
                        console.log(d);
                        navigate("Edit/" + d)
                    }}
                />

            </Paper>

            <Routes>
                <Route path="/Create" element={<UserProfileOfficialNoteDrawer emitOnSave={() => { fetchData(); }} />} />
                <Route path="/Edit/:noteId/" element={<UserProfileOfficialNoteDrawer emitOnSave={() => { fetchData(); }} />} />

            </Routes>
        </>
    );
}